import { TriangleAlert } from "@tamagui/lucide-icons";
import type { Timestamp } from "firebase/firestore";
import { XStack } from "tamagui";
import { getDayJs } from "../../core/dayJs";
import { Body } from "../../ui/Body";

export const DateDue: React.FC<{ dateDue: Timestamp }> = ({ dateDue }) => {
  const isLate = Date.now() > dateDue.toMillis();

  if (isLate) {
    return (
      <XStack alignItems="center" gap="$small">
        <TriangleAlert color={"$danger"} size={16} />
        <Body color="$danger">Due {getDayJs(dateDue)}</Body>
      </XStack>
    );
  }

  return <Body>Due {getDayJs(dateDue)}</Body>;
};
